import axios from 'axios';

const baseUrl = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: baseUrl,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers['x-access-token'] = process.env.REACT_APP_API_KEY;
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export const getFournisseurs = async () => {
  const response = await axiosInstance.get(`${baseUrl}/fournisseurs/all`);
  return response.data;
};

export const addFournisseur = async data => {
  const response = await axiosInstance.post(`${baseUrl}/fournisseurs/ajouter`, data);
  return response.data;
};

export const getFournisseursEntetes = async () => {
  const token = localStorage.getItem('token');
  try {
    const response = await axiosInstance.get('/facturation/factures/2025', {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching sessions:', error);
    throw error;
  }
};
